export var Breakpoint = {
  Xs: 'xs',
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg',
  Xl: 'xl'
};
export var BreakpointClass = {
  Xs: '.sfx-breakpoint-xs',
  Sm: '.sfx-breakpoint-sm',
  Md: '.sfx-breakpoint-md',
  Lg: '.sfx-breakpoint-lg',
  Xl: '.sfx-breakpoint-xl'
};